import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/src/js/ui/photoswipe-ui-default.js';
import { liveEvents } from '../../../../assets/js/application/index.js';

export async function initLightboxes() {
    (await liveEvents()).addEventListener(document, 'click', (event) => {
        if (event.target && event.target.dataset.lightbox) {
            event.preventDefault();

            const _trigger = Symbol(),
                _img = Symbol(),
                trigger = event.target,
                lightboxID = trigger.dataset.lightbox,
                clickedImg =
                    event.target.parentNode.querySelector('img') || event.target.parentNode.querySelector('img'),
                btnShare = document.querySelector('.pswp__button--share');

            let items = new Map(),
                lightboxEl,
                lightbox;

            document.querySelectorAll(`[data-lightbox="${lightboxID}"]`).forEach((trigger) => {
                let img =
                        trigger.parentNode.querySelector(`[data-lightbox-trigger='${lightboxID}']`) ||
                        event.target.parentNode.querySelector('img'),
                    figure = img.closest('figure'),
                    caption = figure ? figure.querySelector('figcaption') : null,
                    item = {
                        [_trigger]: trigger,
                        [_img]: img,
                        src: img.dataset.lightboxImg,
                        w: parseInt(img.getAttribute('width') || img.width, 10),
                        h: parseInt(img.getAttribute('height') || img.height, 10),
                    },
                    title;

                if ((!img.dataset.lightboxCaption || img.dataset.lightboxCaption === 'true') && caption) {
                    title = caption.innerHTML;
                } else if (img.dataset.lightboxCaption && img.dataset.lightboxCaption !== 'false') {
                    title = img.dataset.lightboxCaption;
                }

                item.title = title;

                items.set(img.dataset.lightboxImg, item);
            });

            items = Array.from(items.values());

            lightboxEl = document.querySelector('.pswp');
            lightbox = new PhotoSwipe(lightboxEl, PhotoSwipeUIDefault, items, {
                index: items.findIndex((item) => item.src === clickedImg.dataset.lightboxImg),
                showHideOpacity: true,
                history: true,
                shareEl: true,
                focus: false,
                shareButtons: false,
            });

            lightbox.listen('beforeChange', () => {
                if (/^https?:\/\//i.test(lightbox.currItem.src) === false) {
                    let currentItem = lightbox.currItem.src.startsWith('/')
                        ? lightbox.currItem.src
                        : '/' + lightbox.currItem.src;

                    btnShare.dataset.img = window.location.protocol + '//' + window.location.host + currentItem;
                } else {
                    btnShare.dataset.img = lightbox.currItem.src;
                }
            });

            lightbox.listen('afterInit', () => {
                document.body.classList.add('has-open-lightbox');
                document.body.dataset.lightbox = 'open';
            });

            lightbox.listen('close', () => {
                document.body.classList.remove('has-open-lightbox');
                document.body.dataset.lightbox = 'closed';

                // restore focus on close
                lightbox.currItem[_trigger].focus();
            });

            lightboxEl.addEventListener('focusout', () => {
                // close the lightbox if the focus went out
                requestAnimationFrame(() => {
                    if (
                        document.activeElement !== lightboxEl &&
                        lightboxEl.contains(document.activeElement) === false
                    ) {
                        if (lightboxEl.matches('.pswp--open')) {
                            lightbox.close();
                        }
                    }
                });
            });

            lightbox.init();
        }
    });
}
